import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import routes from "./routes/routes";
import { RouterProvider  } from "react-router-dom";
import {jwtDecode} from "jwt-decode";

const queryClient = new QueryClient();

const isTokenExpired = (token: string) =>{
  try{

    const decodedToken: { exp: number } = jwtDecode(token);
    const currentTime = Date.now() / 1000; // Convert to seconds
    return decodedToken.exp < currentTime;

  }catch(error){
    return true;
  }
}

function AppWrapper() {
  const token = localStorage.getItem("token");

  if (!token) {
    if (window.location.pathname !== "/login") {
      window.location.href = "/login";
      return null;
    }
  } else {
    if (isTokenExpired(token)) {
      localStorage.removeItem("token");
      window.location.href = "/login";
      return null;
    }
  }

  return <RouterProvider router={routes} />;
}



function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AppWrapper/>
    </QueryClientProvider>
  );
}

export default App;
